import { type } from "./type-BCLwAp42.mjs";

//#region node_modules/.deno/rambda@9.4.2/node_modules/rambda/src/isEmpty.js
function isEmpty(input) {
	const inputType = type(input);
	if ([
		"Undefined",
		"NaN",
		"Number",
		"Null"
	].includes(inputType)) return false;
	if (!input) return true;
	if (inputType === "Object") return Object.keys(input).length === 0;
	if (inputType === "Array") return input.length === 0;
	return false;
}

//#endregion
export { isEmpty };
//# sourceMappingURL=isEmpty-B2dexaif.mjs.map